import type { SiteConfig, FooterColumn } from '../../../siteContentTypes.ts';
import { TextField, TextAreaField, ToggleField, ListEditor } from './fields.tsx';

export function FooterSection({ config, update }: { config: SiteConfig; update: (patch: Partial<SiteConfig>) => void }) {
  const f = config.footer;
  const set = (patch: Partial<SiteConfig['footer']>) => update({ footer: { ...f, ...patch } });

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>Footer</h2>
      <TextAreaField label="Description" value={f.description} onChange={(v) => set({ description: v })} rows={2} />
      <ToggleField label="Bloc newsletter activé" value={f.newsletterEnabled} onChange={(v) => set({ newsletterEnabled: v })} />

      <h3 style={{ fontSize: 14, fontWeight: 800, margin: '24px 0 10px' }}>Colonnes</h3>
      <ListEditor<FooterColumn>
        items={f.columns}
        onChange={(columns) => set({ columns })}
        itemLabel="une colonne"
        newItem={() => ({ title: 'Nouvelle colonne', links: [] })}
        renderItem={(col, patch) => (
          <>
            <TextField label="Titre de la colonne" value={col.title} onChange={(v) => patch({ title: v })} />
            <ListEditor
              items={col.links}
              onChange={(links) => patch({ links })}
              itemLabel="un lien"
              newItem={() => ({ label: 'Nouveau lien', url: '#' })}
              renderItem={(link, patchLink) => (
                <>
                  <TextField label="Libellé" value={link.label} onChange={(v) => patchLink({ label: v })} />
                  <TextField label="URL" value={link.url} onChange={(v) => patchLink({ url: v })} />
                </>
              )}
            />
          </>
        )}
      />
    </div>
  );
}
